// Shared hand-drawn toon language for the 3D and compatibility renderers.
// R14 frames the floating island with side and lower cloud banks; no mountains or ground horizon.
export const ART_STYLE_REVISION='handdrawn-toon-cloud-framing-r14';
export const ART_RULES={
 toonRamp:[96,150,205,255],
 environmentOutline:0.018,
 keyOutline:0.026,
 internalInkOpacity:0.62,
 sunColor:'#fff1c9',
 skyColor:'#e8f0f1'
};
export const ART_PALETTE={
 ink:'#40352f', inkSoft:'#6a5e56',
 sky:'#e8f0f1', skyWarm:'#f0f2ef',
 sand:'#d7b478', sandLight:'#e9cd95', sandDark:'#98714e',
 grass:'#8fa45f', grassDark:'#667b48', grassLight:'#acbb78',
 leaf:'#7d9554', leafDark:'#5d7542', leafLight:'#9caf6b',
 bark:'#785548', barkLight:'#9e7562',
 rock:'#aaa69c', rockDark:'#7e7b73', rockLight:'#cbc7bc',
 cliff:'#b88772', cliffDark:'#835f53', cliffLight:'#d1a189',
 cream:'#eee7db', wood:'#9b704f', metal:'#626a64',
 cloud:'#f7f6ef', cloudShade:'#ccd9da', cloudDeep:'#aebfc3'
};
// Small far-away floating islands sit above the cloud sea; they are not land masses.
export const DISTANT_ISLANDS=[[6.0,-.55,-9.8,.48],[-6.4,-1.30,-13.2,.36]];
// High wisps plus two rear cloud strata make the island read as floating above a
// cloud sea. The mid deck sits behind the island's middle/lower silhouette; the
// lower deck fills the view beneath it. All coordinates are background-space x/y/z/scale.
export const CLOUDS=[[-8.2,1.45,-16,.50],[5.7,1.7,-18,.54],[-.8,2.35,-23,.43]];
export const CLOUD_MID_DECK=[[-7.8,-1.72,-11.8,.96],[-3.1,-2.06,-15.2,1.08],[2.1,-1.82,-12.8,1.05],[7.5,-2.08,-15.8,1.12],[-12.1,-7.8,-12.0,1.18],[12.2,-7.9,-12.6,1.22],[-14.3,-10.2,-15.2,.92],[14.4,-10.1,-15.6,.94]];
export const CLOUD_DECK=[[-9.0,-3.92,-10.5,1.42],[-4.2,-4.32,-13.5,1.72],[1.5,-4.08,-12.0,1.62],[6.8,-4.28,-14.8,1.76],[11.1,-4.42,-18.0,1.72],[-6.0,-14.1,-10.0,1.50],[0.0,-15.1,-10.2,1.72],[6.0,-14.2,-10.2,1.52],[-11.8,-13.5,-13.0,1.18],[11.8,-13.6,-13.0,1.20]];
function curve(start,segments){const points=[start];let p=start;for(const [a,b,c]of segments){for(let i=1;i<=12;i++){const t=i/12,u=1-t;points.push([u*u*u*p[0]+3*u*u*t*a[0]+3*u*t*t*b[0]+t*t*t*c[0],u*u*u*p[1]+3*u*u*t*a[1]+3*u*t*t*b[1]+t*t*t*c[1]]);}p=c;}return points;}
export const CLOUD_OUTLINE=curve([-2.8,-.25],[
 [[-3.3,-.05],[-2.95,.5],[-2.35,.48]],
 [[-2.2,1.15],[-1.3,1.1],[-1.02,.65]],
 [[-.5,1.4],[.45,1.4],[.85,.7]],
 [[1.6,1.1],[2.1,.95],[2.25,.45]],
 [[3,.65],[3.3,-.08],[2.7,-.32]],
 [[1,-.5],[-1.4,-.4],[-2.8,-.25]]]);
export const CLOUD_SHADE=curve([-2.8,-.25],[
 [[-1.9,-.17],[-1.65,.05],[-1.05,-.06]],
 [[-.3,-.23],[.12,.18],[.8,-.02]],
 [[1.65,-.2],[2.05,-.02],[2.7,-.32]],
 [[1,-.5],[-1.4,-.4],[-2.8,-.25]]]);
